import React, { useState } from "react";
import {
  ManufacturingDashboard,
  ManufacturingItem,
} from "../../../utils/hooks/manfacturingDashboard";
import { BoardIdContext } from "../../../utils/hooks/commonly-stored/uploaded-board/state-machine/reviewBoardFlowLoader";
import ShipmentCard from "./ShipmentCard";
import Modal from "../../common/Modal";
import ModalContentWithCloseButton from "../../common/ModalContentWithCloseButton";
import DatePicker, {
  ReactDatePickerCustomDayNameProps,
} from "react-datepicker";
import {
  CalendarContainer,
  ClosureDescription,
  DateCell,
  DateHeader,
  DayOfWeekHeader,
  ShipmentsList,
} from "./DashboardStyles";
import { dateStringToDate } from "../../../utils/valueFormatting";
import { DatePickerHeader } from "../../common/FlashPCBDatePicker";
import CalendarItem from "./CalendarItem";

export enum ItemStatus {
  MANUFACTURING = "manufacturing",
  SHIPPED = "shipped",
  LATE = "late",
}

function DayOfWeek({ fullName }: ReactDatePickerCustomDayNameProps) {
  return <DayOfWeekHeader>{fullName}</DayOfWeekHeader>;
}

function datesMatch(leftDate: Date, rightDate: Date): boolean {
  return (
    leftDate.getFullYear() === rightDate.getFullYear() &&
    leftDate.getMonth() === rightDate.getMonth() &&
    leftDate.getDate() === rightDate.getDate()
  );
}

export default function BoardsCalendarView({
  dashboard,
  showManufacturedBoards,
}: {
  dashboard: ManufacturingDashboard;
  showManufacturedBoards: boolean;
}) {
  const [shipmentToShow, setShipmentToShow] =
    useState<ManufacturingItem | null>(null);
  const shipmentsToRender: ManufacturingItem[] = showManufacturedBoards
    ? dashboard.items.concat(dashboard.shipment_history)
    : dashboard.items;

  const renderDate = (day: number, date: Date) => {
    const closure = dashboard.dates_closed.find((closure) => {
      const closureDate = dateStringToDate(closure.date);
      return datesMatch(closureDate, date);
    });

    const itemsForThisDate = shipmentsToRender.filter((i) => {
      const shipDate = dateStringToDate(i.ship_date);
      return datesMatch(shipDate, date);
    });

    return (
      <DateCell closure={closure !== undefined}>
        <DateHeader>
          <div>{day}</div>
          {closure && (
            <ClosureDescription>{closure.description}</ClosureDescription>
          )}
        </DateHeader>
        <ShipmentsList>
          {itemsForThisDate.map((item) => {
            return (
              <CalendarItem
                manufacturingItem={item}
                setShipmentToShow={setShipmentToShow}
                key={item.board_id + item.shipment_id}
              />
            );
          })}
        </ShipmentsList>
      </DateCell>
    );
  };
  return (
    <>
      <CalendarContainer>
        <DatePicker
          renderCustomDayName={DayOfWeek}
          renderDayContents={renderDate}
          renderCustomHeader={DatePickerHeader}
          inline
        />
      </CalendarContainer>

      {shipmentToShow !== null && (
        <Modal isOpen={true} onRequestClose={() => setShipmentToShow(null)}>
          <ModalContentWithCloseButton
            closeModal={() => setShipmentToShow(null)}
          >
            <BoardIdContext.Provider
              key={shipmentToShow.board_id + shipmentToShow.shipment_id}
              value={{
                boardId: shipmentToShow.board_id,
                shipmentId: shipmentToShow.shipment_id,
              }}
            >
              <ShipmentCard />
            </BoardIdContext.Provider>
          </ModalContentWithCloseButton>
        </Modal>
      )}
    </>
  );
}
